// Components
import { Typography, Card, CardContent, Button, Stack, TextField, Divider, Alert } from "@mui/material";

// Icons
import BusinessIcon from "@mui/icons-material/Business";
import { useFormik } from "formik";
import UserService from "../../../../services/UserService";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const CompanyDetails = ({ user, refresh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const servertype = useSelector((state) => state.server.serverType);
  const formik = useFormik({
    initialValues: {
      siret: user?.siret || "",
      siren: user?.siren || "",
      rcs: user?.rcs || "",
      nat: user?.nat || "",
      nis: user?.nis || "",
      nif: user?.nif || "",
    },
    onSubmit: async (values) => {
      setError(null);
      setIsLoading(true);
      try {
        await UserService.update(user.id, values);
        formik.resetForm();
        toast.success("Les informations de l'entreprise ont été mises à jour avec succès.");
        refresh();
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.resetForm({
      values: {
        siret: user?.siret || "",
        siren: user?.siren || "",
        rcs: user?.rcs || "",
        nat: user?.nat || "",
        nis: user?.nis || "",
        nif: user?.nif || "",
      },
    });
  }, [user]);

  return (
    <Card variant="outlined" sx={{ width: "50%" }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, display: "flex", gap: 1 }}>
          <BusinessIcon /> Coordonnées de l'entreprise
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Stack spacing={2}>
          {error && <Alert severity="error">{error.message}</Alert>}
          <Stack direction="row" spacing={2}>
            <TextField label="Raison social" value={user?.society || ""} fullWidth disabled />
            {servertype === "eu" && 
            <TextField label="N° TVA" value={user?.vatNumber || ""} fullWidth  />
     }
          </Stack>
          {servertype === "eu" && 
          <Stack direction="row" spacing={2}>
            <TextField label="N° SIRET" value={formik.values.siret} {...formik.getFieldProps("siret")} fullWidth />
            <TextField label="N° SIREN" value={formik.values.siren} {...formik.getFieldProps("siren")} fullWidth />
          </Stack>
       }  {servertype === "dz" && 
          <Stack direction="row" spacing={2} >
            <TextField label="N° NIS" value={formik.values.nis} {...formik.getFieldProps("nis")} fullWidth />
            <TextField label="N° NIF" value={formik.values.nif} {...formik.getFieldProps("nif")} fullWidth />
          </Stack>
       }
       {servertype === "dz" && 
          <Stack direction="row" spacing={2} >
             <TextField label="NRC" value={formik.values.rcs} {...formik.getFieldProps("rcs")} fullWidth />
          </Stack>
       }
          {servertype === "eu" && 
          <Stack direction="row" spacing={2}>
            <TextField label="RCS" value={formik.values.rcs} {...formik.getFieldProps("rcs")} fullWidth />
            <TextField label="NAF" value={formik.values.nat} {...formik.getFieldProps("nat")} fullWidth />
          </Stack>
           }
          <Button
            variant="contained"
            loading={isLoading}
            disabled={!formik.dirty || !formik.isValid}
            onClick={formik.submitForm}
          >
            Enregistrer
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CompanyDetails;
